import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4cu4uycf: FaireBrandEntity = {
  token: "b_4cu4uycf",
  type: "brand",
  name: "Red Cap Cards",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/afe106ea8544b410ffa42c3236ea412acfe262b9ca2ea7e9d7f3a95225edd6d7/1555027487.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b19ae3032a648ed1775dea0214a6a867c5afa7b0eb9ca082048ea4d1340b8819.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/afe106ea8544b410ffa42c3236ea412acfe262b9ca2ea7e9d7f3a95225edd6d7/1555027487.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b19ae3032a648ed1775dea0214a6a867c5afa7b0eb9ca082048ea4d1340b8819.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 726,
  isTopShop: true,
  isInsider: true,
  description:
    "Red Cap Cards is a celebration of art and correspondence. Each illustrator is hand-selected for their stunning work, individual point-of-view and notable achievements in children’s book illustration, animation, design, and modern art. Red Cap Cards is a platform for artists to reach a broad audience, bringing together the artist’s work and the importance of a handwritten letter. Red Cap Cards products are manufactured in Los Angeles California USA. We print on 100lb heavyweight card stock recycled paper. We produce greeting cards, greeting card boxed sets, gift wrapping paper sheets and rolls, gift bags, and journals. Our products are offset printed with generous letter pressed gold foil accents across the line. We produce cards for many occasions including: anniversary, baby, birthday, congratulations, easter, encouragement, sympathy, every day, father’s day, mother’s day, friendship, halloween, holiday, christmas, hanukkah, love, thank you, valentine, wedding, sympathy. We love producing our groovy, whimsical, cute boutique products and we hope you find something perfect for you!!",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:56.140Z",
    importedBy: "entity-db-cli",
  },
};
